import { call, put, takeEvery } from 'redux-saga/effects';
import { searchByRegRequestSuccess, searchByRegRequestFailure } from '../actions/search_by_reg.actions';
import { SEARCH_BY_REG_REQUEST } from '../constants/search_by_reg.constants';
import { searchBikesByReg } from '../../requests/search_by_reg_request';

function* searchByRegRequest({ searchText }) {
    const regs = yield call(searchBikesByReg, searchText); const
        { msg } = regs;
    regs
        ? yield put(searchByRegRequestSuccess(regs))
        : yield put(searchByRegRequestFailure(msg));
}

export default function* searchByRegSaga() {
    yield takeEvery(SEARCH_BY_REG_REQUEST, searchByRegRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/sagas/search_by_reg.saga.js